export default "__VITE_ASSET__BVnWmYO2__"